import script from "./SensorInjectionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SensorInjectionsView.vue?vue&type=script&setup=true&lang=ts"

import "./SensorInjectionsView.vue?vue&type=style&index=0&id=6aa80ea9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa80ea9"]])

export default __exports__